const view = /*html*/`

    
    <!--begin::Container-->
    <div id="kt_content_container" class="container-fluid">
        <style>
            .top-rank:nth-of-type(1)::after, .top-rank:nth-of-type(2)::after, .top-rank:nth-of-type(3)::after {
                content: "";
                position: absolute;
                left: 0px;
                top: 0px;
                height: 100%;
                width: 100%;
                z-index: 0;                 
                border: 0;
                box-sizing: border-box;
                color: #fff;
                margin: 0;
                padding: 0;
            }
            .top-rank:nth-of-type(1)::after {
                background: linear-gradient(270deg, rgba(31, 31, 31, 0.4) 60.91%, rgba(52, 49, 43, 0.4) 77.74%, rgba(255, 193, 7, 0.4) 102.88%);
            }
            .top-rank:nth-of-type(2)::after {
                background: linear-gradient(270deg, rgba(31, 31, 31, 0.4) 58.44%, rgba(39, 50, 70, 0.4) 78.79%, rgba(71, 94, 138, 0.4) 100%);
            }
            .top-rank:nth-of-type(3)::after {
                background: linear-gradient(270deg, rgba(31, 31, 31, 0.3) 61.73%, rgba(51, 43, 44, 0.3) 80.47%, rgba(119, 78, 55, 0.3) 100%);
            }

            .top-trophy-1{
                color: #ffc107;
            }
            .top-trophy-2{
                color: #C0C0C0;
            }
            .top-trophy-3{
                color: #CD7F32;
            }
            .table-custom
            {
                border-collapse: separate;
                border-spacing: 0 0.5rem;
            }
            
        </style>
        <div class="card card-flush w-100 bgi-position-x-end bgi-position-y-center bgi-no-repeat bgi-size-cover mb-6 px-20" style="height:246px;background-image:url('assets/media/misc/bg_players.png');">
            <div class="d-flex h-100 align-items-center">
                <div class="card-title">
                    <h1 class="fs-2hx text-white teko-header" data-i18n="lb.title">Leaderboards</h1>
                    <p class="text-gray-700 fs-6" data-i18n="lb.subtitle">Are you the best? let's see if you appear here!</p>
                </div>
            </div>            
        </div>
        
        <div class="d-flex row">
            <div class="col-xl-3">
                <div class="card card-flush">           
                    <div class="card-body">
                        <ul class="nav nav-tabs nav-pills flex-row border-0 fs-6 leaders-tab-carousel" role="tablist">
                            <li class="nav-item nav-item-leaders w-unset w-xl-100 me-0 mb-md-2" role="presentation">
                                <a class="leaderboard-tab w-100 btn btn-flex btn-color-gray-muted border border-muted border-active-info border-hover-info btn-active-light-info btn-active-color-info" data-bs-toggle="tab" data-bs-target="#leaderboard-tab-kills" aria-selected="true" role="tab" tab="kills" href="leaderboard/kills" data-navigo>
                                    <i class="fad fa-skull fs-2x pe-0 me-3"></i>
                                    <span class="d-flex flex-column align-items-start">
                                        <span class="fs-4 text-white teko-medium text-uppercase" data-i18n="lb.tab_k">Kills</span>
                                    <span class="fs-8 fw-bold text-gray-700 text-start"  data-i18n="lb.tab_k_sub">Fraggers, assistants..</span></span>
                                </a>
                            </li>
                            <li class="nav-item nav-item-leaders w-unset w-xl-100 me-0 mb-md-2" role="presentation">
                                <a class="leaderboard-tab w-100 btn btn-flex btn-color-gray-muted border border-muted border-active-info border-hover-info btn-active-light-info btn-active-color-info" data-bs-toggle="tab" data-bs-target="#leaderboard-tab-aim" aria-selected="true" role="tab" tab="aim" href="leaderboard/aim" data-navigo>
                                    <i class="fad fa-crosshairs fs-2x pe-0 me-3"></i>
                                    <span class="d-flex flex-column align-items-start">
                                        <span class="fs-4 text-white teko-medium text-uppercase" data-i18n="lb.tab_aim">Aim</span>
                                    <span class="fs-8 fw-bold text-gray-700 text-start" data-i18n="lb.tab_aim_sub">Less shots, more hits</span></span>
                                </a>
                            </li>
                            <li class="nav-item nav-item-leaders w-unset w-xl-100 me-0 mb-md-2" role="presentation">
                                <a class="leaderboard-tab w-100 btn btn-flex btn-color-gray-muted border border-muted border-active-info border-hover-info btn-active-light-info btn-active-color-info" data-bs-toggle="tab" data-bs-target="#leaderboard-tab-multikills" aria-selected="true" role="tab" tab="multikills" href="leaderboard/multikills" data-navigo>
                                    <i class="fad fa-spade fs-2x pe-0 me-3"></i>
                                    <span class="d-flex flex-column align-items-start">
                                        <span class="fs-4 text-white teko-medium text-uppercase" data-i18n="lb.tab_mk">Multikills</span>
                                    <span class="fs-8 fw-bold text-gray-700 text-start" data-i18n="lb.tab_mk_sub">Are you an Ace player?</span></span>
                                </a>
                            </li>
                            <li class="nav-item nav-item-leaders w-unset w-xl-100 me-0 mb-md-2" role="presentation">
                                <a class="leaderboard-tab w-100 btn btn-flex btn-color-gray-muted border border-muted border-active-info border-hover-info btn-active-light-info btn-active-color-info" data-bs-toggle="tab" data-bs-target="#leaderboard-tab-clutches" aria-selected="true" role="tab" tab="clutches" href="leaderboard/clutches" data-navigo>
                                    <i class="fad fa-user-cowboy fs-2x pe-0 me-3"></i>
                                    <span class="d-flex flex-column align-items-start">
                                        <span class="fs-4 text-white teko-medium text-uppercase" data-i18n="lb.tab_cl">Clutches</span>
                                    <span class="fs-8 fw-bold text-gray-700 text-start" data-i18n="lb.tab_cl_sub">The one show men</span></span>
                                </a>
                            </li>
                            <li class="nav-item nav-item-leaders w-unset w-xl-100 me-0 mb-md-2" role="presentation">
                                <a class="leaderboard-tab w-100 btn btn-flex btn-color-gray-muted border border-muted border-active-info border-hover-info btn-active-light-info btn-active-color-info" data-bs-toggle="tab" data-bs-target="#leaderboard-tab-bombs" aria-selected="true" role="tab" tab="bombs" href="leaderboard/bombs" data-navigo>
                                    <i class="fad fa-bomb fs-2x pe-0 me-3"></i>
                                    <span class="d-flex flex-column align-items-start">
                                        <span class="fs-4 text-white teko-medium text-uppercase" data-i18n="lb.tab_bombs">Bombs</span>
                                    <span class="fs-8 fw-bold text-gray-700 text-start" data-i18n="lb.tab_bombs_sub">Boom and fly!</span></span>
                                </a>
                            </li>
                            <li class="nav-item nav-item-leaders w-unset w-xl-100 me-0 mb-md-2" role="presentation">
                                <a class="leaderboard-tab w-100 btn btn-flex btn-color-gray-muted border border-muted border-active-info border-hover-info btn-active-light-info btn-active-color-info" data-bs-toggle="tab" data-bs-target="#leaderboard-tab-maps" aria-selected="true" role="tab" tab="maps" href="leaderboard/maps" data-navigo>
                                    <i class="fad fa-map-signs fs-2x pe-0 me-3"></i>
                                    <span class="d-flex flex-column align-items-start">
                                        <span class="fs-4 text-white teko-medium text-uppercase" data-i18n="lb.tab_maps">Maps</span>
                                    <span class="fs-8 fw-bold text-gray-700 text-start" data-i18n="lb.tab_maps_sub">Where pros play</span></span>
                                </a>
                            </li>
                            <li class="nav-item nav-item-leaders w-unset w-xl-100 me-0 mb-md-2" role="presentation">
                                <a class="leaderboard-tab w-100 btn btn-flex btn-color-gray-muted border border-muted border-active-info border-hover-info btn-active-light-info btn-active-color-info"  data-bs-toggle="tab" data-bs-target="#leaderboard-tab-weapons" aria-selected="true" role="tab" tab="weapons" href="leaderboard/weapons" data-navigo>
                                    <i class="fad fa-axe fs-2x pe-0 me-3"></i>
                                    <span class="d-flex flex-column align-items-start">
                                        <span class="fs-4 text-white teko-medium text-uppercase" data-i18n="lb.tab_w">Weapons</span>
                                        <span class="fs-8 fw-bold text-gray-700 text-start" data-i18n="lb.tab_w_sub">Bang bang bang!</span>
                                    </span>
                                </a>
                            </li>

                            <li class="nav-item nav-item-leaders w-unset w-xl-100 me-0 mb-md-2 d-none" role="presentation">
                                <a class="leaderboard-tab w-100 btn btn-flex btn-color-gray-muted border border-muted border-active-info border-hover-info btn-active-light-info btn-active-color-info"  data-bs-toggle="tab" data-bs-target="#leaderboard-tab-empty" aria-selected="true" role="tab" tab="empty">
                                    <i class="fad fa-axe fs-2x pe-0 me-3"></i>
                                    <span class="d-flex flex-column align-items-start">
                                        <span class="fs-4 text-white teko-medium text-uppercase"></span>
                                        <span class="fs-8 fw-bold text-gray-700 text-start"></span>
                                    </span>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>                
            </div>

            <div class="col overflow-auto">
                <div class="tab-content">
                <div class="tab-pane main-tab fade" id="leaderboard-tab-kills" role="tabpanel">
                        <div class="table-responsive">
                            <!--begin::Table-->
                            <table class="table table-custom align-middle gs-0 gy-4">
                                <!--begin::Table head-->
                                <thead>
                                    <tr class="fw-bold text-gray-600" style="background-color: #1b1b1b">
                                        <th class="ps-4 rounded-start min-w-75px">Pos</th>
                                        <th class="mw-150px" data-i18n="stats.player">Player</th>
                                        <th class="text-nowrap" data-i18n="stats.kills">Kills</th>
                                        <th class="text-nowrap" data-i18n="stats.assists">Assists</th>
                                        <th class="text-nowrap" data-i18n="stats.deaths">Deaths</th>
                                        <th class="text-nowrap" data-toggle="tooltip" title="" data-i18n="[title]stats.ths;[data-bs-original-title]stats.ths">HS</th>
                                        <th class="text-primary text-nowrap" data-toggle="tooltip" title="" data-i18n="[title]stats.ttks;[data-bs-original-title]stats.tkdr">KDR</th>
                                        <th class="text-primary text-nowrap" data-toggle="tooltip" title="" data-i18n="[title]stats.tkpr;[data-bs-original-title]stats.tkpr">KPR</th>
                                        <th class="text-primary text-nowrap" data-toggle="tooltip" title="" data-i18n="[title]stats.tapr;[data-bs-original-title]stats.tapr">APR</th>
                                        <th class="text-primary text-nowrap text-end pe-4 rounded-end" data-toggle="tooltip" title="" data-i18n="[title]stats.thsp;[data-bs-original-title]stats.thsp">HSP</th>                                        
                                    </tr>
                                </thead>
                                <!--end::Table head-->

                                <!--begin::Table body-->
                                <tbody class="table-leaders-kills-body"> 
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="tab-pane main-tab fade" id="leaderboard-tab-aim" role="tabpanel">
                        <div class="table-responsive">
                            <!--begin::Table-->
                            <table class="table table-custom align-middle gs-0 gy-4">
                                <!--begin::Table head-->
                                <thead>
                                    <tr class="fw-bold text-gray-600" style="background-color: #1b1b1b">
                                        <th class="ps-4 rounded-start min-w-75px">Pos</th>
                                        <th class="mw-150px" data-i18n="stats.player">Player</th>
                                        <th class="text-nowrap" data-toggle="tooltip" title="" data-i18n="[title]stats.thits;[data-bs-original-title]stats.thits;stats.hits">Hits</th>
                                        <th class="text-nowrap" data-toggle="tooltip" title="" data-i18n="[title]stats.tshots;[data-bs-original-title]stats.tshots;stats.shots">Shots</th>
                                        <th class="text-nowrap" data-toggle="tooltip" title="" data-i18n="[title]stats.tdamage;[data-bs-original-title]stats.tdamage;stats.damage">Dmg</th>                                        
                                        <th class="text-nowrap" data-toggle="tooltip" title="" data-i18n="[title]stats.thead;[data-bs-original-title]stats.thead;stats.head">Head</th>
                                        <th class="text-nowrap" data-toggle="tooltip" title="" data-i18n="[title]stats.tchest;[data-bs-original-title]stats.tchest;stats.chest">Chest</th>
                                        <th class="text-nowrap" data-toggle="tooltip" title="" data-i18n="[title]stats.tstomach;[data-bs-original-title]stats.tstomach;stats.stomach">Stomach</th>
                                        <th class="text-nowrap" data-toggle="tooltip" title="" data-i18n="[title]stats.tlarm;[data-bs-original-title]stats.tlarm;stats.larm">Left Arm</th>
                                        <th class="text-nowrap" data-toggle="tooltip" title="" data-i18n="[title]stats.trarm;[data-bs-original-title]stats.trarm;stats.rarm">Right Arm</th>
                                        <th class="text-nowrap" data-toggle="tooltip" title="" data-i18n="[title]stats.tlleg;[data-bs-original-title]stats.tlleg;stats.lleg">Left Leg</th>
                                        <th class="text-nowrap" data-toggle="tooltip" title="" data-i18n="[title]stats.trleg;[data-bs-original-title]stats.trleg;stats.rleg">Right Leg</th> 
                                        <th class="text-nowrap text-primary" data-toggle="tooltip" title="" data-i18n="[title]stats.taccuracy;[data-bs-original-title]stats.taccuracy;stats.accuracy">Acc</th>
                                        <th class="text-nowrap text-primary" data-toggle="tooltip" title="" data-i18n="[title]stats.tadr;[data-bs-original-title]stats.tadr">ADR</th>
                                        <th class="text-nowrap text-primary rounded-end pe-4" data-toggle="tooltip" title="" data-i18n="[title]stats.tspk;[data-bs-original-title]stats.tspk">SPK</th>
                                        
                                    </tr>
                                </thead>
                                <!--end::Table head-->

                                <!--begin::Table body-->
                                <tbody class="table-leaders-aim-body"> 
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="tab-pane main-tab fade" id="leaderboard-tab-multikills" role="tabpanel">
                        <div class="table-responsive">
                            <!--begin::Table-->
                            <table class="table table-custom align-middle gs-0 gy-4">
                                <!--begin::Table head-->
                                <thead>
                                    <tr class="fw-bold text-gray-600" style="background-color: #1b1b1b">
                                        <th class="ps-4 rounded-start min-w-75px">Pos</th>
                                        <th class="mw-150px" data-i18n="stats.player">Player</th>                                        
                                        <th class="text-success" data-toggle="tooltip" title="" data-i18n="[title]stats.tk5;[data-bs-original-title]stats.tk5;">5K</th>
                                        <th class="text-zyellow" data-toggle="tooltip" title="" data-i18n="[title]stats.tk4;[data-bs-original-title]stats.tk4;">4K</th>
                                        <th class="text-zblue" data-toggle="tooltip" title="" data-i18n="[title]stats.tk3;[data-bs-original-title]stats.tk3;">3K</th>
                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tk2;[data-bs-original-title]stats.tk2;">2K</th>
                                        <th class="">Total</th>
                                        <th class="text-nowrap text-primary rounded-end pe-4" data-toggle="tooltip" title="" data-i18n="[title]stats.tmkm;[data-bs-original-title]stats.tmkm">MKM</th>
                                    </tr>
                                </thead>
                                <!--end::Table head-->

                                <!--begin::Table body-->
                                <tbody class="table-leaders-multikills-body"> 
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="tab-pane main-tab fade" id="leaderboard-tab-clutches" role="tabpanel">
                        <div class="table-responsive">
                            <!--begin::Table-->
                            <table class="table table-custom align-middle gs-0 gy-4">
                                <!--begin::Table head-->
                                <thead>
                                    <tr class="fw-bold text-gray-600" style="background-color: #1b1b1b">
                                        <th class="ps-4 rounded-start min-w-75px">Pos</th>
                                        <th class="mw-150px" data-i18n="stats.player">Player</th>                                   
                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tv5;[data-bs-original-title]stats.tv5;">v5</th>
                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tv4;[data-bs-original-title]stats.tv4;">v4</th>
                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tv3;[data-bs-original-title]stats.tv3;">v3</th>
                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tv2;[data-bs-original-title]stats.tv2;">v2</th>
                                        <th class="" data-toggle="tooltip" title="" data-i18n="[title]stats.tv1;[data-bs-original-title]stats.tv1;">v1</th>
                                        <th class="">Total</th>
                                        <th class="text-nowrap text-primary rounded-end pe-4" data-toggle="tooltip" title="" data-i18n="[title]stats.tcpm;[data-bs-original-title]stats.tcpm;">CPM</th>
                                    </tr>
                                </thead>

                                <!--end::Table head-->

                                <!--begin::Table body-->
                                <tbody class="table-leaders-clutches-body">
                                </tbody>
                            </table>
                            <!--end::Table-->
                        </div>
                    </div>
                    <div class="tab-pane main-tab fade" id="leaderboard-tab-bombs" role="tabpanel">
                        <div class="table-responsive">
                            <!--begin::Table-->       
                            <table class="table table-custom align-middle gs-0 gy-4">
                                <!--begin::Table head-->
                                <thead>
                                    <tr class="fw-bold text-gray-600" style="background-color: #1b1b1b">
                                        <th class="ps-4 rounded-start min-w-75px">Pos</th>
                                        <th class="mw-150px" data-i18n="stats.player">Player</th>
                                        <th class="" data-i18n="stats.bp">Planted</th>
                                        <th class="" data-i18n="stats.bd">Defused</th>
                                        <th class="" data-i18n="stats.be">Exploded</th>
                                        <th class="text-nowrap" data-i18n="stats.asite">A Site</th>
                                        <th class="text-nowrap" data-i18n="stats.bsite">B Site</th>
                                        <th class="text-primary" data-toggle="tooltip" title="" data-i18n="[title]stats.tbpm;[data-bs-original-title]stats.tbpm;">BPM</th>
                                        <th class="text-primary" data-toggle="tooltip" title="" data-i18n="[title]stats.tbdm;[data-bs-original-title]stats.tbdm;">BDM</th>
                                        <th class="text-primary rounded-end text-nowrap text-end pe-4" data-toggle="tooltip" title="" data-i18n="[title]stats.tbsep;[data-bs-original-title]stats.tbsep;">BSEP</th>
                                    </tr>
                                </thead>
                                <!--end::Table head-->
                                

                                <!--begin::Table body-->
                                <tbody class="table-leaders-bombs-body">
                                </tbody>
                            </table>
                            <!--end::Table-->
                        </div>
                    </div>
                    <div class="tab-pane main-tab fade" id="leaderboard-tab-maps" role="tabpanel">
                        
                        
                    </div>
                    <div class="tab-pane main-tab fade" id="leaderboard-tab-weapons" role="tabpanel">
                        
                        
                    </div>
                </div>
            </div>
        </div>
        
        
    </div>
    <!--end::Container-->

`;


export default view;